import { ImportOutlined, UploadOutlined } from '@ant-design/icons';
import { Alert, Breadcrumb, Button, Card, Col, Divider, message, Progress, Row, Typography, Upload } from 'antd';
import React, { useState } from 'react';
import axios from 'axios';
import { useSelector } from 'react-redux';

const ImportScreen = () => {
  const { Title, Text } = Typography;
  const { darkmode } = useSelector((state) => state.darkmode);
  const [file, setFile] = useState(null);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [isUploading, setIsUploading] = useState(false);

  const handleChange = (info) => {
    // Set file in state when user selects a file
    setFile(info.file); 
    setUploadProgress(0); // Reset progress
  };

  axios.defaults.withCredentials = true;
  const handleUpload = async () => {
    if (!file) {
      message.warning('Please select a file to upload!');
      return;
    }
  
    // Check and log file contents for debugging
    console.log("Selected file object:", file);
    console.log("originFileObj:", file.originFileObj);
  
    const formData = new FormData();
    // Use `originFileObj` if it exists, otherwise fallback to `file`
    formData.append('zerodha', file.originFileObj || file);
  
    setIsUploading(true);
  
    try {
      const response = await axios.post(`${process.env.REACT_APP_BACKEND_URI}/api/v1/zerodha/uploadcsv`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          setUploadProgress(percentCompleted);
        },
      });
  
      message.success(response.data.message || 'File uploaded successfully');
    } catch (error) {
      message.error(error.response?.data?.message || 'File upload failed');
    } finally {
      setIsUploading(false);
      setFile(null); // Reset file after upload
      setUploadProgress(0); // Reset progress after upload
    }
  };
  return (
    <div>
      <Title level={2}><ImportOutlined /> Import Trades</Title>
      <Row style={{ padding: "20px", backgroundColor: darkmode ? "#141414" : "white", borderRadius: "5px" }}>
        <Col flex={"auto"}>
          <Breadcrumb items={[{ title: 'Dashboard' }, { title: 'Import Trades' }]} style={{ marginBottom: "5px" }} />
        </Col>
      </Row>
      <Divider />
      <Row gutter={[16, 24]}>
        <Col xs={24} md={16}>
          <Card>
            <div style={{ padding: 20 }}>
            <Alert type='info' message="Currently software supports only Zerodha Platform" style={{ marginBottom: "10px" }}/>

              <Upload
                fileList={file ? [file] : []} // Only keep the selected file
                onChange={handleChange}
                beforeUpload={() => false} // Prevent auto upload
                maxCount={1} // Limit to a single file
                
              >
                <Button icon={<UploadOutlined />}>Select File</Button>
              </Upload>

              {uploadProgress > 0 && (
                <Progress percent={uploadProgress} style={{ marginTop: 16 }} />
              )}

              <Button
                type="primary"
                onClick={handleUpload}
                loading={isUploading}
                style={{ marginTop: 16, marginBottom: "10px" }}
                disabled={!file || isUploading} // Disable if no file or uploading

              >
                {isUploading ? 'Uploading...' : 'Upload File'}

              </Button>

              {isUploading ? <Alert type='warning' message="File upload in progress. This may take a while due to migrations."/> : ''}
            </div>
          </Card>
        </Col>
        <Col md={8} xs={24}>
          <Card title={<Title level={5}>How to Use Zerodha with Lincfolio?</Title>}>
            <Text>To import trade data from Zerodha, follow these steps:</Text>
            <ol>
              <li>Log in to console.zerodha.com and click on Reports and select Tradebook.</li>
              <li>Select the filters for date and segment according to your preference and click on View.</li>
              <li>Once the list of executions loads, click on Download on the top right corner of the executions table to download the CSV of these executions.</li>
              <li>Save the CSV file to your desktop.</li>
              <li>Upload this file by clicking on the Choose File box in this page.</li>
            </ol>
          </Card>
        </Col>
      </Row>
    </div>
  );
}

export default ImportScreen;
